/**
 * Enum for external data sync operation types
 * Defines what action to perform when syncing to external systems
 */
export var OperationType;
(function (OperationType) {
    /**
     * Create a new entity in the external system
     */
    OperationType["CREATE"] = "create";
    /**
     * Update an existing entity in the external system
     * TODO: Implement UPDATE operation
     */
    OperationType["UPDATE"] = "update";
    /**
     * Delete an entity from the external system
     * TODO: Implement DELETE operation
     */
    OperationType["DELETE"] = "delete";
})(OperationType || (OperationType = {}));
//# sourceMappingURL=OperationType.js.map